import { useLocation } from "@solidjs/router";

export default function NotFound() {
  const location = useLocation();
  return <div class="center">404: '{location.pathname}' not found</div>;
}
